import { Signer } from '@ethersproject/abstract-signer'
import { BigNumber as EthersBigNumber } from '@ethersproject/bignumber'
import { Provider } from '@ethersproject/providers'
import { BigNumber } from '@xylabs/bignumber'
import { EthAddress } from '@xylabs/sdk-js'
import { XyoWorldGeotokens, XyoWorldGeotokens__factory as XyoWorldGeotokensFactory } from '@xyo-network/world-typechain'

import { Quadkey } from '../Quadkey'
import { XyoEthersWrapperBase } from './EthersBase'

class XyoWorldGeotokensWrapper extends XyoEthersWrapperBase {
  public contract: XyoWorldGeotokens

  constructor(address: EthAddress, provider: Provider, signer?: Signer) {
    super(provider, signer)
    this.contract = XyoWorldGeotokensFactory.connect(address.toString(), this.signer ?? this.provider)
  }

  public async erc20Balance(quadkey: Quadkey, erc20Address: EthAddress) {
    return await this.contract?.balanceErc20(quadkey.toString(), erc20Address.toString())
  }

  public async erc20Deposit(quadkey: Quadkey, erc20Address: EthAddress, amount: BigNumber) {
    return await this.contract?.depositErc20(quadkey.toString(), erc20Address.toString(), amount.toString(10))
  }

  public async erc20Withdraw(quadkey: Quadkey, erc20Address: EthAddress, amount: BigNumber) {
    return await this.contract?.withdrawErc20(quadkey.toString(), erc20Address.toString(), amount.toString(10))
  }

  public async exists(quadkey: Quadkey) {
    return await this.contract?.exists(quadkey.toString())
  }

  public async fetchAllQuadkeys() {
    let index: BigNumber | null = new BigNumber(0)
    const result: Quadkey[] = []
    while (index !== null) {
      const quadkey = await this.fetchTokenByIndex(index)
      if (quadkey) {
        result.push(quadkey)
        index = index.addn(1)
      } else {
        index = null
      }
    }
    return result
  }

  public async fetchTokenByIndex(index: BigNumber) {
    try {
      const tokenId = await this.contract.tokenByIndex(index.toString(10))
      if (tokenId) {
        return Quadkey.fromBase10String(XyoWorldGeotokensWrapper.toBigNumber(tokenId)?.toString(10))
      }
    } catch (ex) {
      console.error(ex)
    }
  }

  public async getQuadkeysByOwner(address: EthAddress) {
    const count = (await this.contract.balanceOf(address.toString())).toNumber()

    const promises: Promise<EthersBigNumber>[] = []
    for (let index = 0; index < count; index++) {
      promises.push(this.contract.tokenOfOwnerByIndex(address.toString(), index))
    }
    const ids = await Promise.all(promises)
    return ids.map((id) => Quadkey.fromBase10String(id.toString()))
  }

  public async locked(quadkey: Quadkey) {
    return await this.contract?.locked(quadkey.toString())
  }

  public async ownerOf(quadkey: Quadkey) {
    return EthAddress.fromString(await this.contract?.ownerOf(quadkey.toString()))
  }

  public async tokenByIndex(index: BigNumber) {
    return await this.contract?.tokenByIndex(index.toString())
  }

  public async tokenUri(quadkey: Quadkey) {
    return await this.contract?.tokenURI(quadkey.toString())
  }
}

export { XyoWorldGeotokensWrapper }
